
export default {
  'routeImporter': {
    'loadRouteFile': 'Importer un fichier',
    'failedToLoadFile': 'Échec du chargement du fichier sélectionné. Assurez-vous que le fichier n\'est pas corrompu et dans l\'un des formats acceptés',
    'acceptedImportTypes': 'Types d\'importation acceptés',
    'dictDefaultMessage': 'Déposez un fichier d\'itinéraire à importer ou cliquez ici',
    'dictFallbackMessage': 'Navigateur non pris en charge',
    'dictFileTooBig': 'Fichier trop gros',
    'dictInvalidFileType': 'Type de fichier invalide',
    'dictCancelUpload': 'Annuler le téléchargement',
    'dictUploadCanceled': 'Téléchargement annulé',
    'dictRemoveFile': 'Effacer le fichier'
  }
}
